export default __webpack_public_path__ + "static/media/favicon.ef0b91bd.ico";